import { createSlice } from '@reduxjs/toolkit';

import { loadDataSetConfigsCase } from './cases/loadDataSetConfigs';
import { updateDataSetConfigCase } from './cases/updateDataSetConfig';
import { initialDataSetsState } from './initialState/initialState';

const slice = createSlice({
  name: 'DataSetConfigs',
  initialState: initialDataSetsState,
  reducers: {
    updateDataSetConfig: updateDataSetConfigCase,
    loadDataSetConfigs: loadDataSetConfigsCase,
  },
});

export { slice };
